import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { loginRequest } from '../../../authConfig';
import { AuthResponse } from '../../../utilities/interfaces/AuthResponse';
import { authAPI } from '../../../utilities/api';
import { useAuthorizedController } from '../../../components/stateful/authorized/AuthorizedController';
import { useNotificationHelper } from '../../../utilities/helpers/NotificationHelper';
import { useAppDispatch} from "../../../app/hooks";
import { addTitles, addAgencies } from '../../../features/state/StateAppUser-slice';


export const usePublicHeaderController = () => {
  const isAdminAuthenticated = useIsAuthenticated();
  // TODO: UNCOMMENT THIS AFTER GO LIVE
  const { instance, accounts } = useMsal();
  const { validateRoles } = useAuthorizedController();
  const { addNotification } = useNotificationHelper();

  const dispatch = useAppDispatch();

  useEffect(() => {
    // TODO: UNCOMMENT THIS AFTER GO LIVE
    const trySignin = async () => {
      await RequestProfileData();
    };

    trySignin()
      .then(() => {
        validateRoles();
      })
      .catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdminAuthenticated]);

  const [isDBAuthenticated, setIsDBAuthenticated] = useState<Boolean>(false);

  // TODO: UNCOMMENT THIS AFTER GO LIVE
  async function RequestProfileData() {
    if (!isAdminAuthenticated) {
      return;
    }

    // Silently acquires an access token which is then attached to a request for MS Graph data
    await instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0] ?? {},
      })
      .then(async (response) => {
        var userDetails: AuthResponse = await authAPI.validateUser(response.accessToken)
        .catch((error: any) => {
          addNotification({
            type: 'error',
            message: `Login Error: ${error.message}`,
          });
        });

        setIsDBAuthenticated(!!userDetails);
        if (!!userDetails) {
          dispatch(addTitles(userDetails.titleClaims));
          dispatch(addAgencies(userDetails.agencyClaims));

          sessionStorage.setItem('token', JSON.stringify(userDetails.jwtToken));
          sessionStorage.setItem('roles', JSON.stringify(userDetails.userRoles));
        } else {
          console.warn('Failed to fetch user roles');
        }
      });
  }

  return {
    isAdminAuthenticated,
    isDBAuthenticated,
    accounts,
  };
};
